/* 子组件：Header / TableSection / DoraSection / HandSection / FlagsSection / ResultSection / Keyboard / HistoryDrawer / SettingsDrawer */

const _Tile = window.Tile;

// ====================== Header ======================
function Header({ th, s, onHistory, onSettings, onClear }) {
  return (
    <div style={s.header}>
      <div>
        <div style={s.title}>雀点 <span style={{ color: th.accent, fontFamily: '"PingFang SC","Hiragino Mincho ProN","Songti SC",ui-serif,serif' }}>·</span> 算</div>
        <div style={s.subtitle}>JP MAHJONG SCORE</div>
      </div>
      <div style={{ display: 'flex', gap: 6 }}>
        <IconBtn th={th} onClick={onHistory} label="历史">⏱</IconBtn>
        <IconBtn th={th} onClick={onSettings} label="设置">⚙</IconBtn>
        {onClear && <IconBtn th={th} onClick={onClear} label="清空">↺</IconBtn>}
      </div>
    </div>
  );
}

function IconBtn({ th, onClick, children, label }) {
  return (
    <button onClick={onClick} title={label}
      style={{
        width: 32, height: 32, borderRadius: 4,
        background: 'transparent', border: `1px solid ${th.line}`,
        color: th.ink2, fontSize: 14, cursor: 'pointer',
        display: 'flex', alignItems: 'center', justifyContent: 'center'
      }}>{children}</button>
  );
}

// ====================== TableSection (局况) ======================
function TableSection({ th, s, roundWind, setRoundWind, seatWind, setSeatWind, honba, setHonba, deposit, setDeposit }) {
  const winds = [['1z', '東'], ['2z', '南'], ['3z', '西'], ['4z', '北']];
  return (
    <div>
      <div style={s.sectionLabel}>
        <span>局　况</span>
        <span style={{ flex: 1, height: 1, background: th.line, opacity: 0.6 }}></span>
      </div>
      <div style={{ padding: '4px 12px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
        {/* 场风 */}
        <div style={{ background: th.panel, padding: '8px 10px', borderRadius: 4, border: `1px solid ${th.line}` }}>
          <div style={{ fontSize: 9, color: th.ink2, letterSpacing: '0.2em', marginBottom: 4 }}>场风</div>
          <div style={{ display: 'flex', gap: 4 }}>
            {winds.map(([k, v]) => (
              <button key={k} onClick={() => setRoundWind(k)}
                style={{
                  flex: 1, padding: '4px 0', border: 'none',
                  background: roundWind === k ? th.accent : 'transparent',
                  color: roundWind === k ? '#fff' : th.ink2,
                  fontFamily: '"PingFang SC","Hiragino Mincho ProN","Songti SC",ui-serif,serif', fontSize: 14, cursor: 'pointer', borderRadius: 2
                }}>{v}</button>
            ))}
          </div>
        </div>
        {/* 自风 */}
        <div style={{ background: th.panel, padding: '8px 10px', borderRadius: 4, border: `1px solid ${th.line}` }}>
          <div style={{ fontSize: 9, color: th.ink2, letterSpacing: '0.2em', marginBottom: 4 }}>
            自风 {seatWind === '1z' && <span style={{ color: th.accent, fontWeight: 600 }}>· 亲</span>}
          </div>
          <div style={{ display: 'flex', gap: 4 }}>
            {winds.map(([k, v]) => (
              <button key={k} onClick={() => setSeatWind(k)}
                style={{
                  flex: 1, padding: '4px 0', border: 'none',
                  background: seatWind === k ? th.accent : 'transparent',
                  color: seatWind === k ? '#fff' : th.ink2,
                  fontFamily: '"PingFang SC","Hiragino Mincho ProN","Songti SC",ui-serif,serif', fontSize: 14, cursor: 'pointer', borderRadius: 2
                }}>{v}</button>
            ))}
          </div>
        </div>
      </div>
      {/* 立直棒 / 本场 */}
      <div style={{ padding: '4px 12px 8px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
        <Stepper th={th} label="立直棒" value={deposit} onChange={setDeposit} max={9} icon="┃" />
        <Stepper th={th} label="本场" value={honba} onChange={setHonba} max={20} icon="●" />
      </div>
    </div>
  );
}

function Stepper({ th, label, value, onChange, max = 99, icon }) {
  return (
    <div style={{ background: th.panel, padding: '8px 10px', borderRadius: 4, border: `1px solid ${th.line}`, display: 'flex', alignItems: 'center' }}>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 9, color: th.ink2, letterSpacing: '0.2em' }}>{label}</div>
        <div style={{ fontSize: 18, fontWeight: 600, color: th.ink, fontFamily: '"PingFang SC","Hiragino Mincho ProN","Songti SC",ui-serif,serif', display: 'flex', alignItems: 'baseline', gap: 4 }}>
          {value}
          <span style={{ fontSize: 9, color: th.accent }}>{Array.from({length: Math.min(value, 5)}).map((_,i)=>icon).join('')}</span>
        </div>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <button onClick={() => onChange(Math.min(max, value + 1))}
          style={{ width: 28, height: 18, border: `1px solid ${th.line}`, background: th.surface, color: th.ink2, fontSize: 10, cursor: 'pointer', borderRadius: 2 }}>+</button>
        <button onClick={() => onChange(Math.max(0, value - 1))}
          style={{ width: 28, height: 18, border: `1px solid ${th.line}`, background: th.surface, color: th.ink2, fontSize: 10, cursor: 'pointer', borderRadius: 2 }}>−</button>
      </div>
    </div>
  );
}

// ====================== DoraSection ======================
function DoraSection({ th, s, doraInds, setDoraInds, uraInds, setUraInds, focus, setFocus, riichi }) {
  const slot = (which, list, setList) => {
    const isFocus = focus === which;
    return (
      <div onClick={() => setFocus(which)}
        style={{
          flex: 1, background: th.panel,
          border: `1px solid ${isFocus ? th.accent : th.line}`,
          borderRadius: 4, padding: '8px 8px 6px',
          cursor: 'pointer', position: 'relative',
          minHeight: 56,
          boxShadow: isFocus ? `0 0 0 2px ${th.accent}22` : 'none'
        }}>
        <div style={{ fontSize: 9, color: th.ink2, letterSpacing: '0.2em', marginBottom: 4 }}>
          {which === 'dora' ? '宝牌指示' : '里宝指示'}
          {isFocus && <span style={{ color: th.accent, marginLeft: 4 }}>● 选中</span>}
        </div>
        <div style={{ display: 'flex', gap: 3, alignItems: 'center', minHeight: 36 }}>
          {list.length === 0 && (
            <div style={{ fontSize: 10, color: th.ink2, opacity: 0.5 }}>—</div>
          )}
          {list.map((t, i) => (
            <_Tile key={i} tile={t} size={26}
              onClick={(e) => { e.stopPropagation(); setList(list.filter((_, j) => j !== i)); }} />
          ))}
        </div>
      </div>
    );
  };
  return (
    <div>
      <div style={s.sectionLabel}>
        <span>宝　牌</span>
        <span style={{ flex: 1, height: 1, background: th.line, opacity: 0.6 }}></span>
        <span style={{ fontSize: 9, color: th.ink2 }}>点击牌移除 · 立直可设里宝</span>
      </div>
      <div style={{ padding: '0 12px', display: 'flex', gap: 8 }}>
        {slot('dora', doraInds, setDoraInds)}
        {riichi && slot('ura', uraInds, setUraInds)}
      </div>
    </div>
  );
}

// ====================== HandSection ======================
function HandSection({ th, s, hand, agariTile, melds, meldDraft, focus, setFocus, removeHandTile, setAsAgari, removeMeld, confirmMeld, startMeld }) {
  const isFocus = focus === 'hand';
  return (
    <div>
      <div style={s.sectionLabel}>
        <span>手　牌</span>
        <span style={{ flex: 1, height: 1, background: th.line, opacity: 0.6 }}></span>
        <span style={{ fontSize: 9, color: th.ink2 }}>{hand.length} 张{agariTile && ' · 点牌设和'}</span>
      </div>

      <div onClick={() => { setFocus('hand'); }}
        style={{
          ...s.handTray,
          borderColor: isFocus ? th.accent : th.line,
          boxShadow: isFocus ? `0 0 0 2px ${th.accent}22` : 'none',
        }}>
        <div style={s.handLabel}>手牌</div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'flex-end' }}>
          {hand.length === 0 && (
            <div style={{ fontSize: 11, color: th.ink2, opacity: 0.5, padding: '14px 0' }}>从下方键盘选牌 →</div>
          )}
          {hand.map((t, i) => {
            const isAgari = agariTile === t && hand.lastIndexOf(t) === i;
            return (
              <div key={i} style={{ position: 'relative' }}>
                <_Tile tile={t} size={36}
                  glow={isAgari}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (isAgari) removeHandTile(i);
                    else setAsAgari(t);
                  }}
                  style={{
                    transform: isAgari ? 'translateY(-6px)' : 'none',
                    marginLeft: isAgari ? 4 : 0,
                  }}
                />
                {isAgari && (
                  <div style={{
                    position: 'absolute', bottom: -6, left: '50%', transform: 'translateX(-50%)',
                    fontSize: 8, color: th.accent, fontFamily: '"PingFang SC","Hiragino Mincho ProN","Songti SC",ui-serif,serif', letterSpacing: '0.1em', whiteSpace: 'nowrap'
                  }}>和</div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* 副露 */}
      {(melds.length > 0 || meldDraft) && (
        <div style={{ margin: '8px 12px', padding: '8px 10px', background: th.surface, border: `1px solid ${th.line}`, borderRadius: 6 }}>
          <div style={{ fontSize: 10, color: th.ink2, letterSpacing: '0.2em', marginBottom: 6 }}>副露</div>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'flex-end' }}>
            {melds.map((m, i) => (
              <MeldDisplay key={i} th={th} meld={m} onClick={() => removeMeld(i)} />
            ))}
            {meldDraft && (
              <div style={{
                padding: '4px 6px', border: `1px dashed ${th.accent}`, borderRadius: 4,
                background: th.accent + '11'
              }}>
                <div style={{ fontSize: 9, color: th.accent, marginBottom: 2 }}>{meldLabel(meldDraft.type)}（输入中）</div>
                <div style={{ display: 'flex', gap: 1 }}>
                  {meldDraft.tiles.length === 0 && <div style={{ fontSize: 10, color: th.ink2, padding: '8px' }}>选牌…</div>}
                  {meldDraft.tiles.map((t, i) => <_Tile key={i} tile={t} size={28} />)}
                </div>
                {meldDraft.tiles.length > 0 && (
                  <button onClick={confirmMeld}
                    style={{ marginTop: 4, fontSize: 10, padding: '2px 8px', background: th.accent, color: '#fff', border: 'none', borderRadius: 2, cursor: 'pointer' }}>确认</button>
                )}
              </div>
            )}
          </div>
        </div>
      )}

      {/* 副露按钮 */}
      <div style={{ padding: '4px 12px', display: 'flex', gap: 6 }}>
        {[['chii', '吃'], ['pon', '碰'], ['minkan', '明杠'], ['ankan', '暗杠']].map(([k, v]) => (
          <button key={k} onClick={() => startMeld(k)} disabled={!!meldDraft}
            style={{
              flex: 1, padding: '6px 0', fontSize: 12, letterSpacing: '0.15em',
              border: `1px solid ${th.line}`, background: th.panel, color: th.ink,
              borderRadius: 4, cursor: meldDraft ? 'not-allowed' : 'pointer',
              opacity: meldDraft ? 0.5 : 1, fontFamily: '"PingFang SC","Hiragino Mincho ProN","Songti SC",ui-serif,serif'
            }}>{v}</button>
        ))}
      </div>
    </div>
  );
}

function meldLabel(t) { return { chii: '吃', pon: '碰', minkan: '明杠', ankan: '暗杠' }[t]; }

function MeldDisplay({ th, meld, onClick }) {
  // 视觉：吃/碰一张横放，杠四张
  return (
    <div onClick={onClick} style={{ cursor: 'pointer', position: 'relative' }}>
      <div style={{ display: 'flex', alignItems: 'flex-end', gap: 0 }}>
        {meld.type === 'ankan' ? (
          <>
            <_Tile tile="ura" size={26} />
            <_Tile tile={meld.tiles[1]} size={26} />
            <_Tile tile={meld.tiles[2]} size={26} />
            <_Tile tile="ura" size={26} />
          </>
        ) : meld.type === 'minkan' ? (
          <>
            <_Tile tile={meld.tiles[0]} size={26} variant="h" />
            <_Tile tile={meld.tiles[1]} size={26} />
            <_Tile tile={meld.tiles[2]} size={26} />
            <_Tile tile={meld.tiles[3]} size={26} />
          </>
        ) : meld.type === 'pon' ? (
          <>
            <_Tile tile={meld.tiles[0]} size={26} variant="h" />
            <_Tile tile={meld.tiles[1]} size={26} />
            <_Tile tile={meld.tiles[2]} size={26} />
          </>
        ) : (
          <>
            <_Tile tile={meld.tiles[0]} size={26} variant="h" />
            <_Tile tile={meld.tiles[1]} size={26} />
            <_Tile tile={meld.tiles[2]} size={26} />
          </>
        )}
      </div>
      <div style={{ fontSize: 9, color: th.ink2, textAlign: 'center', marginTop: 2 }}>{meldLabel(meld.type)}</div>
    </div>
  );
}

// ====================== FlagsSection ======================
function FlagsSection({ th, s, by, setBy, riichi, setRiichi, doubleRiichi, setDoubleRiichi, ippatsu, setIppatsu, special, setSpecial }) {
  const Toggle = ({ active, onClick, children, color }) => (
    <button onClick={onClick}
      style={{
        padding: '6px 12px', fontSize: 12,
        border: `1px solid ${active ? (color || th.accent) : th.line}`,
        background: active ? (color || th.accent) : th.panel,
        color: active ? '#fff' : th.ink2,
        borderRadius: 4, cursor: 'pointer',
        lineHeight: 1.3, fontFamily: '"PingFang SC","Hiragino Mincho ProN","Songti SC",ui-serif,serif',
        whiteSpace: 'nowrap', flexShrink: 0,
        minWidth: 'fit-content'
      }}>{children}</button>
  );
  return (
    <div>
      <div style={s.sectionLabel}>
        <span>状　况</span>
        <span style={{ flex: 1, height: 1, background: th.line, opacity: 0.6 }}></span>
      </div>
      <div style={{ padding: '0 12px 6px', display: 'flex', gap: 6, flexWrap: 'wrap' }}>
        <Toggle active={by === 'tsumo'} onClick={() => setBy('tsumo')} color={th.gold}>自摸</Toggle>
        <Toggle active={by === 'ron'} onClick={() => setBy('ron')} color={th.accent}>荣和</Toggle>
        <span style={{ width: 1, background: th.line, margin: '0 2px' }}></span>
        <Toggle active={riichi && !doubleRiichi} onClick={() => { setRiichi(!riichi); if (doubleRiichi) setDoubleRiichi(false); }}>立直</Toggle>
        <Toggle active={doubleRiichi} onClick={() => { setDoubleRiichi(!doubleRiichi); if (!doubleRiichi) setRiichi(true); }}>双立直</Toggle>
        {(riichi || doubleRiichi) && <Toggle active={ippatsu} onClick={() => setIppatsu(!ippatsu)}>一发</Toggle>}
      </div>
      <div style={{ padding: '0 12px 8px', display: 'flex', gap: 6, flexWrap: 'wrap' }}>
        {[['rinshan', '岭上'], ['chankan', '抢杠'], ['haitei', '海底河底'], ['tenhou', '天和'], ['chiihou', '地和']].map(([k, v]) => (
          <Toggle key={k} active={special === k} onClick={() => setSpecial(special === k ? null : k)}>{v}</Toggle>
        ))}
      </div>
    </div>
  );
}

window._UIComponents1 = { Header, TableSection, DoraSection, HandSection, FlagsSection };
Object.assign(window, { Header, TableSection, DoraSection, HandSection, FlagsSection });
